import { _post, _get, _delete } from "./Axios";

export default class JabatanApi {
  static get(id = null) {
    if (id == null) {
      return _get("masterdata/jabatan");
    } else {
      return _get("masterdata/jabatan/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("masterdata/jabatan?" + params);
  }
  static post(data) {
    return _post("masterdata/jabatan", data);
  }
  static update(id, data) {
    return _post("masterdata/jabatan/" + id, data);
  }
  static changePassword(id, data) {
    return _post("masterdata/jabatan/" + id + "/changepassword", data);
  }
  static delete(id) {
    return _delete("masterdata/jabatan/" + id);
  }
  static check_token(data) {
    return _post("auth/checktoken/", data);
  }
  static getGroups() {
    return _get("masterdata/jabatangroups/");
  }
}
